import Vue from 'vue'
import MediaContainer from '@/components/MediaContainer.vue'

interface MediaModalOption {
  menus?: string[]
  mediaUrl: string
  mediaType: 'photo' | 'video'
  mediaThumbnail?: string
  requestUrl: string
  requestParams: any
  savePhotoPoint?: string
  saveVideoPoint?: string
}

export default Vue.extend({
  data() {
    return {
      $_modal: null,
      $_orgHashMediaModal: ''
    }
  },
  destroyed() {
    this.$_closeMediaModal()
  },
  methods: {
    /**
     * MediaModal の表示
     */
    $_showMediaModal(options: MediaModalOption) {
      const props = {
        hasModalCard: true,
        mediaUrl: options.mediaUrl,
        mediaType: options.mediaType,
        mediaThumbnail: options.mediaThumbnail,
        savePhotoPoint: options.savePhotoPoint,
        saveVideoPoint: options.saveVideoPoint,
        requestUrl: options.requestUrl,
        requestParams: options.requestParams
      }
      if (options.menus) {
        props['menus'] = options.menus
      }

      this.$_modal = this.$amatamodal.open({
        parent: this,
        props: props,
        component: MediaContainer,
        onCancel: this.$_closeMediaModal,
        scrollLock: true,
        scrollEnableSelector: 'html'
      })

      if (this.$_modal) {
        window.addEventListener('popstate', this.$_closeMediaModal, false)
        if (this.$_platformIsAndroid) {
          document.addEventListener('backbutton', this.$_closeMediaModal, false)
        }
      }
    },

    /**
     * MediaModal の非表示
     */
    $_closeMediaModal() {
      if (this.$_modal) {
        this.$_modal.close()
        this.$_modal = null
        window.removeEventListener('popstate', this.$_closeMediaModal, false)
        if (this.$_platformIsAndroid) {
          document.removeEventListener('backbutton', this.$_closeMediaModal, false)
        }
      }
    }
  }
})
